import { UserTicketCollapsedByUserInterface } from '../../..';
import { TicketSaleQuantityInformationDto } from './ticket-sale-quantity-information.dto';
import { UserDto } from '../../..';

export class UserTicketCollapsedByUserDto implements UserTicketCollapsedByUserInterface {
  user: UserDto;
  ticketSaleInformation: TicketSaleQuantityInformationDto[];
}
